import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { useQuery } from "@tanstack/react-query"
import { OnboardingStepperContext } from "@/pages/onboarding/onboardingStepper"
import Onboarding from "@/pages/onboarding"
import { useOnboardingStore } from "@/stores/useOnboardingStore"
import { useEffect } from "react"
import { getToptaalUserByFreelanceToken } from "@/api/services/toptaalUser"
import { authQueryKeys } from "@/api/query-keys/auth"
import { useAuthStore } from "@/stores/useAuthStore"

export const Route = createFileRoute("/onboarding/$token")({
  component: RouteComponent,
})

function RouteComponent() {
  const { logout } = useAuthStore()

  const { token } = useParams({
    from: "/onboarding/$token",
  })

  const { setDataFromApi } = useOnboardingStore()
  const router = useRouter()

  useEffect(() => {
    // Clear auth store on onboarding start
    logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  const { status, data } = useQuery({
    queryKey: authQueryKeys.onboarding(token),
    queryFn: () =>
      getToptaalUserByFreelanceToken(token).catch((error) => {
        if (error.response.status === 401) {
          router.navigate({
            to: "/onboarding/ongeldige_token",
          })
        }
      }),
  })

  useEffect(() => {
    if (status === "success" && data) {
      setDataFromApi(data)
    }
  }, [status, data, setDataFromApi])

  return (
    <OnboardingStepperContext>
      <Onboarding />
    </OnboardingStepperContext>
  )
}
